import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import ReviewStars from "../ReviewStars/ReviewStars";
import { Directions, translationConstants } from "../../../constants";
import { sportNames } from "../../../modules/AdminPortal/Views/Spots/utilities";
import DummyImage from "../../../assets/images/icon/dummyCenterLogo.png";

const ViewCenterCard = ({ center, handleViewDetails }) => {
  const { t } = useTranslation();

  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );

  return (
    <div className="col-sm-6 col-md-6 col-lg-4 center-details-card-wrapper p-2">
      <div
        className="centers-detail-card cast-shadow-on-hover"
        onClick={() => handleViewDetails(center?.id)} // Handle click event
      >
        <div className="row m-0 w-100">
          <div className="col-7 col-md-6 d-flex justify-content-center align-items-center p-0">
            <div className="center-image-wrapper">
              <img src={center?.logo?.link || DummyImage} alt="center" />
            </div>
          </div>
          <div className="col-5 col-md-6 px-3 py-1 d-flex justify-content-start align-items-center">
            <div className="center-card-content-wrapper d-flex flex-column justify-content-between h-100-percent">
              <div>
                <span className="center-card-heading">
                  {direction === Directions.rtl && center?.arabicName
                    ? center.arabicName
                    : center?.name}
                </span>
                <div className="center-card-sports-name">
                  {center?.sports.map((sportId) => (
                    <span key={sportId}>{t(sportNames[sportId])}</span>
                  ))}
                </div>
              </div>
              <div>
                <div className="center-card-review-wrapper py-1">
                  {center?.overallRating > 0 && (
                    <ReviewStars value={center?.overallRating} size={10} />
                  )}
                  {`${center?.noOfReviews || 0} ${t(
                    translationConstants.REVIEWS
                  )}`}
                </div>
                <span
                  className="center-card-view-detail-link approved-color"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleViewDetails(center?.id);
                  }}
                >
                  {t(translationConstants.VIEW_DETAILS)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCenterCard;
